module.exports = __webpack_public_path__ + "static/media/arrow-back-green.ca0eb9e9.svg";